// © Microsoft Corporation. All rights reserved.

let clientSettings: ClientSettings;

/** The client settings object. */
export interface ClientSettings {
    /** The name of the app */
    apptype: string;

    /** The name of the page */
    pagetype: string;

    /** The activity ID */
    aid: string;

    /** The PCS page generation time in ISO 8601 format, UTC. */
    pageGenTime?: string;

    /** Information about the JS bundles we are running. */
    bundleInfo: {
        /** The build number for the JS bundles. */
        v: string;
    }

    /** Information about PCS that created the page. */
    pcsInfo: {
        /** The environment we are on */
        env: string;

        /** The build number for PCS. */
        v: string;
    }
}

/**
 * Gets the client settings object.
 */
export function getPageSettings(): ClientSettings {
    if (!clientSettings) {
        const settingsJson: string = document.head.getAttribute("data-client-settings");
        if (settingsJson) {
            clientSettings = JSON.parse(settingsJson);
        }
    }

    return clientSettings;
}

/**
 * Checks if the DOM is available to access and use.
 * @returns {boolean} - true if DOM is available, or false if it is not. This is typically true for
 * client side rendering and false for server side rendering.
 */
export function canUseDOM(): boolean {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}